<template>
  <div class="wrapper" :class="[
      { 'nav-open': $sidebar.showSidebar }
    ]">
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu></user-menu>
      <mobile-menu></mobile-menu>

      <template slot="links">
        <!-- Dashboard -->
        <sidebar-item
          :link="{ id: 1, name: $lang.menu.dashboard, icon: 'dashboard', path: '/applied-precision/dashboard' }"
        ></sidebar-item>

        <!-- Meters -->
                <sidebar-item
          :link="{ name: 'Meters', icon: 'cable', path: '/applied-precision/meters' }"
        ></sidebar-item>

        <!-- <sidebar-item :link="{ name: 'Meters', icon: 'cable' }">
          <sidebar-item :link="{ name: 'Add meter', path: '/applied-precision/meter/add' }"></sidebar-item>

          <sidebar-item :link="{ name: 'Meters list', path: '/applied-precision/meters' }"></sidebar-item>

          <sidebar-item :link="{ name: 'Test list', path: '/applied-precision/meter/tests' }"></sidebar-item>
        </sidebar-item> -->

        <!-- Profile section -->
        <!--         <sidebar-item :link="{ name: $lang.menu.profile, icon: 'timeline' }">
          <sidebar-item
            :link="{ name: $lang.menu.voltage, path: '/visualization/profile/voltage' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.current, path: '/visualization/profile/current' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.active_power, path: '/visualization/profile/power/active' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.reactive_power, path: '/visualization/profile/power/reactive' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.apparent_power, path: '/visualization/profile/power/apparent' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.energy_import, path: '/visualization/profile/energy/import' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.reactive_energy, path: '/visualization/profile/energy/reactive' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.apparent_energy, path: '/visualization/profile/energy/apparent' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.frequency, path: '/visualization/profile/frequency' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.power_factor, path: '/visualization/profile/power-factor' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.df_voltage, path: '/visualization/profile/distoration-factor/voltage' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.df_current, path: '/visualization/profile/distoration-factor/current' }"
          ></sidebar-item>
        </sidebar-item>-->

        <!-- Energy section -->
        <!--         <sidebar-item :link="{ name: $lang.menu.analytics, icon: 'assessment' }">
          <sidebar-item
            :link="{ name: $lang.menu.quarter_hour_maximum_active_report, path: '/visualization/energy/active/15min/maximum' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.quarter_hour_active_report, path: '/visualization/energy/active/15min' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.hourly_active_report, path: '/visualization/energy/active/hour' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.daily_active_report, path: '/visualization/energy/active/day' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.monthly_active_report, path: '/visualization/energy/active/month' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.daily_reactive_report, path: '/visualization/energy/reactive/day' }"
          ></sidebar-item>
        </sidebar-item>-->

        <!-- RealTime section -->
        <sidebar-item :link="{ name: 'Measurements', icon: 'update' }">
          <sidebar-item
            :link="{ name: $lang.menu.vector_diagram, path: '/applied-precision/vector' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.harmonics_chart, path: '/applied-precision/harmonics' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.waveform_chart, path: '/applied-precision/waveform' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.voltage, path: '/visualization/realtime/voltage' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.current, path: '/visualization/realtime/current' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.active_power, path: '/visualization/realtime/power/active' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.reactive_power, path: '/visualization/realtime/power/reactive' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.apparent_power, path: '/visualization/realtime/power/apparent' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.energy_import, path: '/visualization/realtime/energy/import' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.reactive_energy, path: '/visualization/realtime/energy/reactive' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.apparent_energy, path: '/visualization/realtime/energy/apparent' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.frequency, path: '/visualization/realtime/frequency' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.power_factor, path: '/visualization/realtime/power-factor' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.df_voltage, path: '/visualization/realtime/distortion-factor/voltage' }"
          ></sidebar-item>

          <sidebar-item
            :link="{ name: $lang.menu.df_current, path: '/visualization/realtime/distortion-factor/current' }"
          ></sidebar-item>
        </sidebar-item>

        <!-- Tools section -->
        <!--         <sidebar-item :link="{ name: $lang.menu.tools, icon: 'build' }">
          <sidebar-item :link="{ name: $lang.menu.monitoring, path: '/tools/monitoring' }"></sidebar-item>

          <sidebar-item :link="{ name: $lang.menu.notifications, path: '/tools/notifications' }"></sidebar-item>
        </sidebar-item>-->
      </template>
    </side-bar>

    <Loader v-show="getLoading"></Loader>

    <div class="main-panel" v-show="!getLoading">
      <top-navbar></top-navbar>

      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import Loader from "@/components/Loader";

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "@/pages/Layout/ContentFooter.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";
import UserMenu from "@/pages/Layout/UserMenu.vue";

import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    UserMenu,
    ZoomCenterTransition,
    Loader
  },

  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: "/img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true
    };
  },

  computed: {
    notifications() {
      return this.$store.getters.getNotificationList;
    },
    getAuth() {
      return this.$store.getters.getAuth;
    },
    deviceList() {
      return this.$store.getters.getDeviceList;
    },
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
    getLoading() {
      return this.$store.getters.getLoading;
    }
  },

  watch: {
    notifications: function() {
      const notificationJSON = this.notifications[0];

      //STATUS
      if (notificationJSON.type === "STATUS") {
        let notifyString =
          "<b>" +
          this.$lang.titles.notify_device_status +
          "</b><br>" +
          this.$lang.messages.device_status_change +
          " " +
          notificationJSON.data.event;

        this.showNotification(notifyString);
      }
    }
  },

  methods: {
    showNotification: function(msg) {
      this.$notify({
        message: msg,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "info"
      });
    },

    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  mounted() {
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");
      initScrollbar("main-panel");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.main-panel > .content {
  padding: 8px 15px;
}

.charts {
  min-height: 500px;
  height: 70vh;
  width: 100%;
}
</style>
